import React, { useState, useContext } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { AuthContext } from "../../../../auth-context";
import Button from "../../../../components/button";
import { SelectUsers } from "../campaign/select-users";
import { loadProfile, assignToGroup, removeFromGroup } from "../../../../api";
import { Row, Action } from '../../../../components/action-button'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import SearchIcon from '@material-ui/icons/Search'
import _ from 'lodash';

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`;

const TableTitle = styled.h2`
  padding: 16px 0;
  margin: 0 auto;
  color: #555;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`;

const TableContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 700px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`;

const Table = styled.table`
  background: #fff;
  border-spacing: 0px;
  width: 100%;
`;

const TableHead = styled.thead`
  color: #fff;
`;

const TableBody = styled.tbody``;

const TableHeadRow = styled.tr``;

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`;

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${(props) => (props.bigWidth ? "160px" : "100px")};
  padding: 8px;
  position: sticky;
  top: 0;
  z-index: 30;
`;

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px;
  text-align: center;
`;

const ButtonCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-size: 0.875rem;
  text-align: center;
  padding: 8px 12px;
  white-space: nowrap;

  button {
    background: ${(props) => props.theme.button.background};
    border: none;
    border-radius: ${(props) => props.theme.button.borderRadius};
    color: ${(props) => props.theme.button.color};
    cursor: pointer;
    font-family: ${(props) => props.theme.font.secondary};
    font-weight: 500;
    height: 36px;
    width: 100px;
    transition: 0.2s ease opacity;
    &:hover {
      opacity: 0.8;
    }
  }
`;

const Group = (props) => {
  const groupId = Number(props.match.params.id);
  const { user, updateUser } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const handleSubmit = (selected) => {
    assignToGroup(user.id, selected, groupId)
      .then((r) => {
        setShow(false);
        loadProfile(user.id).then((res) => {
          updateUser(res.data.profile);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleDelete = (accountId) => {
    removeFromGroup(user.id, accountId, groupId)
      .then(function (response) {
        let newUser = _.cloneDeep(user)
        const assignedGroups = user.accounts.find(a => a.id === accountId).groups
        const newAssignedGroups = _.without([...assignedGroups], groupId)
        const groupIndex = newUser.groups.findIndex(u => u.id === groupId)
        const accountIndex = newUser.accounts.findIndex(u => u.id === accountId)
        newUser.groups[groupIndex].client_count = newUser.groups[groupIndex].client_count - 1
        newUser.accounts[accountIndex].groups = newAssignedGroups
        updateUser(newUser)     
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  }
  let groupName = "";
  let clients = [];
  if (user) {
    if (user.groups) {
      for (let n = 0; n < user.groups.length; ++n) {
        if (user.groups[n].id === groupId) {
          groupName = user.groups[n].name;
          user.accounts.forEach((a) => {
            if (a.groups.includes(groupId)) {
              clients.push({
                id: a.id,
                email_address: a.email_address,
                name: a.name,
                claimed: a.claimed,
              });
            }
          });
          break;
        }
      }
    }
  }

  const currentSelected = [];
  user.accounts.forEach((a) => {
    if (
      a.user_id !== null &&
      (a.manager_id === user.id || a.trainers.includes(user.id)) &&
      a.trainer_permission === 1
    ) {
      let already = false;
      for (let n = 0; n < clients?.length; ++n) {
        if (clients[n].id === a.id) {
          already = true;
          break;
        }
      }
      if (already) {
        currentSelected.push({
          id: a.id,
          email_address: a.email_address,
          name: a.name,
          claimed: a.claimed,
        });
      }
    }
  });

  return (
    <>
      <Container>
        <Button label="Add Clients to Group" onClick={() => setShow(true)} />
        <TableTitle>{groupName}</TableTitle>
        <TableContainer>
          <Table>
            <TableHead>
              <TableHeadRow>
                <HeadCell>Email Address</HeadCell>
                <HeadCell>Full Name</HeadCell>
                <HeadCell>Claimed</HeadCell>
                <HeadCell>Actions</HeadCell>
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {clients.map((entry, index) => (
                <TableBodyRow key={entry.id}>
                  <DataCell>{entry.email_address}</DataCell>
                  <DataCell>{entry.name}</DataCell>
                  <DataCell>{entry.claimed === 1 ? "Yes" : "No"}</DataCell>
                  <ButtonCell>
                    <Row>
                      {entry.claimed === 1 && (
                        <Action
                          icon={<SearchIcon/>}
                          text="Inspect"
                          onClick={() => props.history.push(`/dashboard/inspect/${entry.id}/overview`)}
                        />
                      )}
                      <Action
                        icon={<DeleteIcon />}
                        iconColor='#da0f0f'
                        text="Delete"
                        onClick={() => handleDelete(entry.id)}
                      />
                    </Row>
                  </ButtonCell>
                </TableBodyRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
      <SelectUsers
        currentSelected={currentSelected}
        submit={handleSubmit}
        open={show}
        onClose={() => setShow(false)}
      />
    </>
  );
};

export default withRouter(Group);
